import { useCallback } from "react";

import { useRailbarPortalContext } from "./RailbarPortalContext";

const getContextPosition = (id: string): "header" | "content" | null => {
  if (id === "rail-bar-header") return "header";
  if (id === "rail-bar-content") return "content";
  return null;
};

export const RailbarContainer = ({
  id = "rail-bar-header",
  className,
}: {
  className?: string;
  id?: string;
}) => {
  const ctx = useRailbarPortalContext();
  const position = getContextPosition(id);
  // `registerTarget` has empty deps in the provider — depending on the
  // whole `ctx` would re-run the ref callback on every provider state
  // change (each registration mutates `getTarget`, which mutates `ctx`)
  // and detach/re-attach the portal target in a loop.
  const registerTarget = ctx?.registerTarget;

  const refCallback = useCallback(
    (el: HTMLDivElement | null) => {
      if (!registerTarget || !position) return;
      registerTarget(position, el);
    },
    [registerTarget, position],
  );

  return <div id={id} className={className} ref={refCallback} />;
};

export const PageRailbarContainer = RailbarContainer;
